import React from 'react';

import {
  TableContainer,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Link,
  Box,
} from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';

import Status from '../Status';

const Amendments = ({ amendments, onOpenDetails }) => {
  return (
    <TableContainer>
      <Table width={'100%'}>
        <TableBody>
          {amendments?.map((row) => {
            const { id, period, status } = row;
            return (
              <TableRow>
                <TableCell>
                  {period && period.from && period.to ? (
                    <Link onClick={(e) => onOpenDetails(e, { id })}>
                      <DateRangeFormatter
                        value={[period.from, period.to]}
                        template={'MMM yy'}
                        timeZone={'local'}
                      />
                    </Link>
                  ) : null}
                </TableCell>
                <TableCell width={156} align={'right'}>
                  <Box display={'inline-block'} mr={2}>
                    <Status id={status.id}>{status.name}</Status>
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Amendments;
